import { assignInlineVars } from '@vanilla-extract/dynamic'
import { xStack } from '../../patterns/stack'
import { circle, delayVar } from './DotPulse.css'

export function DotPulse() {
  return (
    <div className={xStack({ gap: 'xs' })}>
      <span
        className={circle}
        aria-hidden="true"
        style={assignInlineVars({
          [delayVar]: '0s',
        })}
      />
      <span
        className={circle}
        aria-hidden="true"
        style={assignInlineVars({
          [delayVar]: '0.1s',
        })}
      />
      <span
        className={circle}
        aria-hidden="true"
        style={assignInlineVars({
          [delayVar]: '0.2s',
        })}
      />
    </div>
  )
}
